<template>
    <div>
        <div class="content">
            <div class="cont-list">
                <span class="list">{{
                    this.parentRoute.menuName + "-" + this.route.menuName
                }}</span>
                <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
            </div>
            <div class="header">
                <div class="left">

                    <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary"
                        @click="exportData" v-loading="exportButtonLoading"
                        :disabled="exportButtonLoading">导出</el-button>

                    <SelectFilter ref="selectFilter" :options="filterOptions" :query="query"
                        @filterChange="filterChange" @reset="reset"></SelectFilter>
                </div>
                <div class="right">
                    <div class="search">
                        <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
                            <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
                        </el-input>
                        <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
                    </div>
                    <span v-preventReClick @click="reset">重置</span>
                </div>
            </div>

            <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData"
                :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe
                :header-cell-style="{ background: '#DDEBFF' }">
                <template slot="empty">
                    <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                        <img src="../../../../assets/noData.png" width="240" height="240" />
                        <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                        <div class="empty-rest" @click="reset">恢复默认</div>
                    </div>
                </template>
                <el-table-column type="index" label="序号" width="55"> </el-table-column>
                <el-table-column prop="settlementModeName" label="结算模式" width="170" />
                <el-table-column show-overflow-tooltip prop="tableTypeName" width="160" label="单据类型" />
                <el-table-column show-overflow-tooltip prop="tableNo" width="180" label="单号" />
                <el-table-column show-overflow-tooltip width="80" prop="stockCategoryName" label="类型" />
                <el-table-column show-overflow-tooltip width="120" prop="deptName" label="科室" >
                  <template slot-scope="scope">
                    {{ scope.row.deptName?scope.row.deptName:'-' }}
                  </template>
                </el-table-column>
                <el-table-column width="180" prop="createdTime" label="发生时间">
                    <template slot-scope="scope">{{
                         scope.row.effectiveTime ? parseTime(new Date(scope.row.effectiveTime)) : "-"
                    }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="supplierName" label="供应商" />
                <el-table-column show-overflow-tooltip prop="secondSupplierName" min-width="180" label="二级供应商" >
                  <template slot-scope="scope">
                    {{ scope.row.secondSupplierName?scope.row.secondSupplierName:'-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="supplierProductNo" label="供应商产品编码" min-width="160"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="productName" label="产品名称" min-width="160"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="specName" label="规格型号" min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="manufacturerName" label="生产厂家" min-width="160"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="batch" label="批次号" min-width="160" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.batch?scope.row.batch:'-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="serialNo" label="序列号" width="120">
                  <template slot-scope="scope">
                    {{ scope.row.serialNo?scope.row.serialNo:'-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="manufactureDate" label="生产日期" width="150">
                    <template slot-scope="scope">
                      {{ scope.row.manufactureDate ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}") : "-" }}
                    </template>
                  </el-table-column>
                <el-table-column width="120" label="有效期">
                    <template slot-scope="scope">{{
                        scope.row.validityDate ? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}") : "-"
                    }}</template>
                </el-table-column>
                <el-table-column prop="longTime" label="是否长期" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.longTime == 1 ? "是" : "否" }}
                    </template>
                </el-table-column>
                <el-table-column prop="mainNo" width="100" label="主条码" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.mainNo?scope.row.mainNo:'-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="traceNo" width="100" label="溯源码" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.traceNo?scope.row.traceNo:'-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="number" label="数量" min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="minUnit" label="最小单位" min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="price" label="价格" min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="amount" label="金额" min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="productRegistNo" label="注册证号" min-width="160"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="productTypeName" label="产品类型" min-width="160"
                    show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination background layout="sizes, prev, pager, next, jumper"
                :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize"
                @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total"
                @current-change="changePage">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {
    GetSettlementViewModels,
    RemoveBillRegister,
    GetAcceptInStocks,
    ExportBillRegister,
    GetAcceptOutStocks,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import { ApproveStatusOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
    mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
    components: {
        SelectFilter,
    },
    data() {
        return {
            GetDatasAction: GetSettlementViewModels,
            RemoveAction: RemoveBillRegister,
            exportAction: ExportBillRegister,
            // PrintAction: GetAcceptInStockPrintData,
            editPath: "bill-register-edit",

            // ApproveStatusOptions: ApproveStatusOptions,
            filterOptions: [
                {
                    name: "单号",
                    type: "input",
                    code: "tableNo",
                },
                {
                    name: "供应商",
                    type: "select",
                    code: "supplierId",
                    filterMethod: this.getSuppliers,
                    data: [],
                },
                {
                    name: "二级供应商",
                    type: "input",
                    code: "secondSupplierName",
                },
                {
                    name: "产品名称",
                    type: "input",
                    code: "productName",
                },
                {
                    name: "规格型号",
                    type: "input",
                    code: "specName",
                },
                {
                    name: "生产厂家",
                    type: "input",
                    code: "manufacturerName",
                },
                {
                    name: "供应商产品编码",
                    type: "input",
                    code: "supplierProductNo",
                },
                {
                    name: "时间范围",
                    type: "datetimerange",
                    code: "createdDate",
                    format: 'yyyy-MM-dd HH:mm:ss',
                    startDateCode: "startCreatedDate",
                    endDateCode: "endCreatedDate",
                },
           
            ],
        };
    },
    methods: {
        getAcceptInStockList(keyWord) {
            return new Promise((resolve, reject) => {
                GetAcceptInStocks({ keyWord: keyWord, pageIndex: 1, pageSize: 100 }).then(
                    (res) => {
                        // this.acceptInStockList = res.returnData.data
                        resolve(res.returnData.data);
                    }
                );
            });
        },
        getAcceptOutStockList(keyWord) {
            return new Promise((resolve, reject) => {
                GetAcceptOutStocks({ keyWord: keyWord, pageIndex: 1, pageSize: 100 }).then(
                    (res) => {
                        // this.acceptInStockList = res.returnData.data
                        resolve(res.returnData.data);
                    }
                );
            });
        },


    },
    mounted() { 
    let date = [
        this.parseTime(new Date(new Date().getFullYear(),new Date().getMonth()-1,new Date().getDate()), "{y}-{m}-{d} {h}:{i}:{s}"),this.parseTime(new Date(), "{y}-{m}-{d} {h}:{i}:{s}") 
        ]
    this.$set(this.query,'createdDate',date)

    this.query.startDate = this.query.date[0]
    this.query.endDate = this.query.date[1]
    },
};
</script>

<style lang="scss" scoped></style>